import { programLabels } from '@/config';
import { ProgramName } from '@/types/global';

const AssistanceRequestAmountInfo = ({ data, program }: { data: any; program: ProgramName }) => {
  return (
    <div>
      <h1 className="mb-4 text-xl md:text-2xl font-bold">{programLabels[program].title}</h1>

      <div className="rounded-lg bg-gray-100 p-4">
        <div>
          <div className="space-y-2">
            <p>
              <strong>Assistance requested: </strong>${data.estimated_patient_out_of_pocket}
            </p>
            <p>
              <strong>Assistance authorized: </strong>${data.total_amount_paid}
            </p>
            <p>
              <strong>Remaining assistance: </strong>${data.remaining_benefit_amount}
            </p>
          </div>
          <div className="space-y-2 mt-2">
            {data.status === 'eob_paid' && (
              <p>
                <strong>EOB out of pocket: </strong>${data.amount_paid}
              </p>
            )}
            <p>
              <strong>Reimbursement: </strong>
              {data.status === 'eob_pending' &&
                "Submit the EOB for this fill from the patient's primary insurance."}
              {data.status === 'eob_in_review' &&
                'The EOB is under review. You will be notified via email if any clarification is required.'}
              {data.status === 'eob_paid' &&
                `$${data?.amount_paid} (Note: Please allow 2 to 3 weeks for payment to be issued after EOB has been approved.)`}
            </p>
            {data.dispensing_pharmacy_npi && (
              <p>
                <strong>Dispensing NPI: </strong>
                {data.dispensing_pharmacy_npi}
              </p>
            )}
            {data.dispensing_pharmacy_tax_id && (
              <p>
                <strong>Dispensing Tax ID: </strong>
                {data.dispensing_pharmacy_tax_id}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssistanceRequestAmountInfo;
